import { generatePath } from "react-router-dom";

export const pathPatterns = {
    awards: '/',
    award : '/award/:awardId',
    categories : "/award/:awardId/categories/",
    category : "/award/:awardId/category/:categoryId",
    categoryEntry : "/award/:awardId/category/:categoryId/entry/:entryId",
    entry : "/award/:awardId/entry/:entryId",
    notes : "/notes",
    mylist : "/mylist"
}

export const generatePathAwards = () => {
    return generatePath(pathPatterns.awards, {});
}

export const generatePathMyList = () => {
    return generatePath(pathPatterns.mylist, {});
}

export const generatePathAward = (awardId) => {
    return generatePath(pathPatterns.award, {
        awardId
    });
}

export const generatePathEntry = (awardId, entryId) => {
    return generatePath(pathPatterns.entry, {
        awardId, entryId
    });
}

export const generatePathCategories = (awardId) => {
    return generatePath(pathPatterns.categories, {
        awardId
    });
}

export const generatePathCategory = (awardId, categoryId) => {
    return generatePath(pathPatterns.category, {
        awardId,
        categoryId,
    });
}

export const generatePathCategoryEntry = (awardId, categoryId, entryId) => {
    return generatePath(pathPatterns.categoryEntry, {
        awardId,
        categoryId,
        entryId,
    });
}

export const generatePathEntriesByCategory = (awardId, categoryId) => {
    return generatePath(pathPatterns.award, {
        awardId
    })+`?fixedCategories[]=${categoryId}`;
}

export const generatePathNotes = () => {
    return generatePath(pathPatterns.notes, {});
}

export const generatePathMyListEntry = (baseEntryLink) => {
    return baseEntryLink + "?myListEntry=true"
}

export const convertObjectIntoQueryString = (initialObj, objToQS) => {
    return Object.keys(objToQS).map(key => {
        if(Array.isArray(objToQS[key])) {
            return objToQS[key].map( value => {
                return `${key}[]=${value}`
            }).filter(n => n).join('&');
        }
        return initialObj[key] === objToQS[key] ? '' :`${key}=${objToQS[key]}`
    }).filter(n => n).join('&');
}

export const mapQueryStringIntoObject = (query, QSToObject) => {

    let resultObj = {}
    for(var key in QSToObject) {
        if(query.has(`${key}[]`)) {
            resultObj[key] = query.getAll(`${key}[]`)
        } 
        else if(query.has(key)) {
            const value = query.get(key).trim();
            if(typeof QSToObject[key] === "boolean") {
                resultObj[key] = value === "true" ? true : false
            }
            else {
                resultObj[key] = value
            }
        }
    }
    return resultObj
}

export function getQueryParams(queryString) {
    const params = new URLSearchParams(queryString)
    
    const result = [...params.keys()].reduce((builder, key) => {
        if(key.endsWith("[]")) {
            const realKey = key.slice(0, -2);
            builder[realKey] = params.getAll(key)
        }
        else {
            builder[key] = params.get(key);
        }
        return builder;
    }, {});

    //console.log("PARAMS", result);
    return result;
}

export function getQueryParamsAndParse(queryString, structure, config) {
    return parseParams(getQueryParams(queryString), structure, config);
}

export const mergeParamsIntoQueryString = (currentQueryString, newParams = {}) => {
    const currentParams = getQueryParams(currentQueryString);
    const mergedParams = {...currentParams, ...newParams};
    return convertObjectIntoQueryString({}, mergedParams);
}

export const removeParamsFromQueryString = (currentQueryString, removeParams = []) => {
    const currentParams = getQueryParams(currentQueryString);
    const newParams = Object.fromEntries(Object.entries(currentParams)
        // keep entries that aren't in the removeParams array
        .filter(([key, value]) => removeParams.indexOf(key) === -1)
    );
    return convertObjectIntoQueryString({}, newParams);
}

export function parseParams(params, structure, { removeUnknown = false } = {}) {
    // loop through all the params and parse then according to structure object
    const parsedParams = Object.fromEntries(Object.entries(params)
        .map(([paramKey, value]) => {
            // if a structure obj for this param exists, try and parse
            const paramStructure = structure[paramKey];
            if(removeUnknown && typeof paramStructure === "undefined") return null;

            let newValue = value;
            
            // if the type is array then loop through each item and parse the items using the subType
            if(paramStructure?.type === "array") {
                newValue = value?.length ? value.map(subValue => parseAsType(paramStructure?.subType, subValue)) : value;
            }
            else {
                newValue = parseAsType(paramStructure?.type, value);
            }

            if(paramStructure?.custom) {
                newValue = paramStructure?.custom(newValue);
            }

            return [paramKey, newValue];
        })
        .filter(x => x)
    );

    return parsedParams;
}

function parseAsType(type, value) {
    switch(type) {
        case "int":
            return parseInt(value);
        case "float":
            return parseFloat(value);
        case "string":
            return ""+value;
        case "json":
            return JSON.parse(value);
        case "bool":
            return Boolean((""+value).toLocaleLowerCase().trim() === "true" || value === 1);
        default:
            return value;
    }
}

export function mapParamValues(params, callback) {
    const mappedParams = Object.fromEntries(Object.entries(params)
        .map(([paramKey, value]) => {
            let newValue;
            // if the type is array then loop through each item and parse the items using the subType
            if(Array.isArray(value)) {
                newValue = value.map(subValue => callback(subValue));
            }
            else {
                newValue = callback(value);
            }

            return [paramKey, newValue];
        })
    );
    return mappedParams;
}